// extracted by mini-css-extract-plugin
module.exports = {"fixedHeader":"src-layouts-Header-module__fixedHeader--26q2I"};